import { genToolTip, formateXaxis } from './utils';
const colors = ['#0080FF', '#08D69E', '#713FE0', '#FE8E20'];
function genLegendData(data) {
    return data.catagory && data.catagory.map((item) => {
        return {
            name: item.name,
            icon: 'circle',
        };
    });
}
function genSeriesData(data) {
    return data.catagory && data.catagory.map((item, i) => {
        const transfromData = item.yAxis.map((value) => {
            return { value };
        });
        return {
            type: 'bar',
            barGap: 0,
            barWidth: 8,
            itemStyle: {
                color: colors[i],
                borderWidth: 1,
                borderColor: '#fff',
            },
            name: item.name,
            data: transfromData,
        };
    });
}
export default function traffic7Days(data) {
    const legendData = genLegendData(data);
    const seriesData = genSeriesData(data);
    const timeObj = formateXaxis(data.xAxis);
    return {
        grid: { bottom: 50, top: 16, left: 20, right: 20 },
        legend: {
            bottom: -4,
            itemWidth: 6,
            itemHeight: 6,
            itemGap: 32,
            padding: [5, 8, 5, 5],
            data: legendData,
            textStyle: {
                color: '#5e5e66',
            },
        },
        tooltip: {
            backgroundColor: '#fff',
            textStyle: {
                color: '#000',
                fontSize: 12,
            },
            formatter(params) {
                return genToolTip(params, { map: timeObj.map });
            },
            extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.15);',
        },
        xAxis: {
            type: 'category',
            boundaryGap: [32, 32],
            axisTick: {
                show: false,
            },
            data: timeObj.time,
            axisLine: {
                lineStyle: {
                    color: '#ccc',
                },
            },
        },
        yAxis: {
            type: 'value',
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: '#ededf0',
                },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: false,
            },
        },
        series: seriesData,
    };
}
